(ns app.front.ui.dom
  (:require [re-frame.core-instrumented :as rf]))

(defn set-body-class! [[class on?]]
  (let [body (.-body js/document)]
    (when body
      (if on?
        (.add (.-classList body) class)
        (.remove (.-classList body) class)))))

(defn set-head-style! [id css-text]
  (let [style-el (or (.getElementById js/document id)
                     (let [style-el (doto (.createElement js/document "style")
                                      (.setAttribute "id" id))]
                       (.appendChild (.-head js/document) style-el)
                       style-el))]
    (set! (.-textContent style-el) (or css-text ""))))

(rf/reg-fx ::set-body-class set-body-class!)

(rf/reg-event-fx ::toggle-body-overflow
  (fn [{:keys [db]} _]
    (let [should-hide-overflow-max-lg? (:app.front.ui.panels/mobile-menu-open? db)]
      {:fx [[::set-body-class ["max-lg:overflow-hidden" should-hide-overflow-max-lg?]]]})))
